// extracted by mini-css-extract-plugin
export var orderDetails = "_ki-2";
export var orderImage = "_ki-1";
export var orderMeta = "_ki-3";
export var orderSummary = "_ki-0";
export var rightArrow = "_ki-4";